const cities = [
  { name: "Titusville", zips: "32780, 32796" },
  { name: "Mims", zips: "32754" },
  { name: "Scottsmoor", zips: "32775" },
  { name: "Port St. John", zips: "32927" },
  { name: "Cape Canaveral", zips: "32920" },
  { name: "Cocoa", zips: "32922, 32926" },
  { name: "Merritt Island", zips: "32952, 32953" },
  { name: "Rockledge", zips: "32955" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home or office in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function TitusvilleLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Titusville &amp; Northern Brevard County
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in Titusville, Mims, Scottsmoor, or anywhere in northern Brevard County, Fast Passport Center makes expedited passport processing simple — no drive to Miami, no agency lines, no guessing.
          </p>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Titusville sits at the northern gateway to Florida's Space Coast, where the Indian River Lagoon meets the threshold of American space exploration. With a population of approximately 48,000, Titusville is defined by its front-row seat to history — the Vehicle Assembly Building at Kennedy Space Center dominates the eastern horizon across the lagoon, and rocket launches from Cape Canaveral Space Force Station light up the sky from Space View Park, the best public launch viewing location on the Space Coast. The city's identity is inseparable from the space program, and generations of aerospace engineers, NASA contractors, and their families have called Titusville home since the Mercury, Gemini, and Apollo eras.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The aerospace workforce of Titusville is central to its travel patterns. NASA employees at Kennedy Space Center, SpaceX engineers and technicians at Launch Complex 39A, Blue Origin personnel at their manufacturing facility, and contractors from Boeing, Lockheed Martin, and United Launch Alliance travel internationally for satellite integration, launch partner coordination, ISS mission planning, and technical conferences. Launch campaigns from Cape Canaveral operate on compressed, unpredictable timelines — payload reviews in Toulouse, component integration in Bremen, and partner meetings in Tokyo are confirmed with weeks rather than months of notice. An aerospace professional with an expired passport and a launch campaign approaching has no margin for standard processing.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Launch tourism has become a defining feature of Titusville's economy and travel patterns. SpaceX Falcon 9 and Falcon Heavy launches draw tens of thousands of spectators to Titusville's waterfront parks, hotels, and restaurants. The upcoming Artemis missions to the Moon and future Mars missions will drive an unprecedented wave of international space tourism to Titusville. Launch chasers — photographers, journalists, and enthusiasts who travel the world documenting rocket launches — regularly travel from Titusville to launch sites in French Guiana (Ariane), New Zealand (Rocket Lab), Kazakhstan (Soyuz), and China. These travelers follow launch manifests that shift constantly, with credential approvals and mission assignments often arriving with days or weeks of notice.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Beyond aerospace, Titusville's location along the Indian River Lagoon shapes its outdoor and recreational travel. The lagoon is a world-class destination for fishing, kayaking, and wildlife viewing — manatees, dolphins, and hundreds of bird species inhabit its waters. Titusville residents, like other Space Coast communities, also cruise from Port Canaveral (about 25 miles south), surf at nearby Playalinda Beach and Cocoa Beach, and vacation in the Bahamas, Caribbean, and Central America. The Canaveral National Seashore, accessible from Titusville's northern end, offers pristine, undeveloped Atlantic coastline that draws nature enthusiasts and beachgoers from across Florida.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            The geographic reality of Titusville matters for passport processing. The closest regional passport agency is in Miami, approximately 195 miles south via I-95 and the Florida Turnpike — a drive that consumes three to four hours. For a NASA engineer who discovers an expired passport the week before an ISS payload review in Japan, or a launch photographer credentialed for an Ariane 6 mission in French Guiana leaving in four days, that drive is not just inconvenient — it's non-viable. Fast Passport Center's courier-based expedited service means you start online from your Titusville home — and your passport arrives within days, not months.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Delray Beach</p>
                  <p className="text-white/60 text-xs mt-0.5">401 W Atlantic Ave #351, Delray Beach, FL 33444</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Nearest office to Titusville — approximately 175 miles south via I-95
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Brevard County</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Delray Beach office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Brevard County — start online, ship overnight, and we handle the rest. No need to drive to Miami.
              </p>
            </div>

            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Cocoa Beach", href: "/cocoa-beach" },
                  { name: "Melbourne", href: "/melbourne" },
                  { name: "Orlando", href: "/orlando" },
                  { name: "Daytona Beach", href: "/daytona-beach" },
                  { name: "Port St. Lucie", href: "/port-st-lucie" },
                  { name: "Stuart", href: "/stuart" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}